import { render, staticRenderFns } from "./UserPassword.form.vue?vue&type=template&id=04161cc6&"
import script from "./UserPassword.form.vue?vue&type=script&lang=js&"
export * from "./UserPassword.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports